export function dateToYYYYMMDD(date: Date): string | undefined {
  if (typeof date !== "object") {
    return undefined;
  }

  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  const paddedMonth = `0${month}`.slice(-2);
  const paddedDay = `0${day}`.slice(-2);

  return `${year}${paddedMonth}${paddedDay}`;
}

export function parseDate(dateString: string): Date | undefined {
  const date = new Date(Date.parse(dateString));

  if (isNaN(date.valueOf())) {
    return undefined;
  } else {
    return date;
  }
}

export interface DateDetails {
  year: string;
  month: string;
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}

export function dateToDetailsObject(date: Date): DateDetails {
  return {
    year: date.getFullYear().toString(),
    month: `${(date.getMonth() + 1).toString().padStart(2, "0")}`,
    day: `${date
      .getDate()
      .toString()
      .padStart(2, "0")}`,
    hours: `${date
      .getHours()
      .toString()
      .padStart(2, "0")}`,
    minutes: `${date
      .getMinutes()
      .toString()
      .padStart(2, "0")}`,
    seconds: `${date
      .getSeconds()
      .toString()
      .padStart(2, "0")}`
  };
}

export function dateTimeStringToLocaleString(dateTimeString: string) {
  if (!dateTimeString) return;

  const dateToday = new Date(Date.now());
  const dateParsed = parseDate(dateTimeString);

  if (!dateParsed) return;

  const today = dateToDetailsObject(dateToday);

  const date = dateToDetailsObject(dateParsed);

  const time = `${date.hours}:${date.minutes}`;

  if (today.day === date.day) {
    return `${date.hours}:${date.minutes}`;
  } else {
    return `${date.year}/${date.month}/${date.day} ${time}`;
  }
}
